import { useAuthStore } from "@/lib/auth-store";

/**
 * El `persist` middleware de Zustand hidrata desde localStorage de forma
 * asíncrona en el primer mount. Las route guards de TanStack Router corren
 * en `beforeLoad` ANTES de mount · si chequean `accessToken` directo, lo
 * verán null aun habiendo sesión guardada y mandarían al usuario a /login.
 *
 * Esta helper espera a que termine la rehidratación · idempotente y
 * cacheable (devuelve la misma promesa).
 */
let hydrationPromise: Promise<void> | null = null;

export function waitForAuthHydration(): Promise<void> {
  if (useAuthStore.persist.hasHydrated()) {
    return Promise.resolve();
  }
  if (hydrationPromise) return hydrationPromise;
  hydrationPromise = new Promise<void>((resolve) => {
    const unsub = useAuthStore.persist.onFinishHydration(() => {
      unsub();
      resolve();
    });
  });
  return hydrationPromise;
}
